<template>
<div class="island">
	
	<b-navbar toggleable="sm" type="dark" variant="" class="navbar-container lp-submenu">
		<b-container>
			<b-nav tabs>
				<b-nav-item class="link" to="/">Explore</b-nav-item>
				<b-nav-item class="link" to="/Students/prek">Preschool-K</b-nav-item>
				<b-nav-item class="link" to="/Students/1to3">Grades 1-3</b-nav-item>
				<b-nav-item class="link" to="/Students/4to6">Grades 4-6</b-nav-item>
				<b-nav-item class="link" to="/Students/7up">Grades 7+</b-nav-item>
			</b-nav>
		</b-container>
	</b-navbar>

	<b-container class="student-container">
	<b-row>
		<b-col sm='8' >
			<b-list-group class="game-select">
				<b-list-group-item active class="heading">
					<h4 class="list-group-item-heading text-center">Choose an activity:</h4>
				</b-list-group-item>
			
				<b-list-group-item class="semitransparent" v-for="(game,idx) in games" :key="idx" @mouseenter="gameHover(game)" @click="gameClick(game)">
					<b-row>
						<b-col cols="2" class="game-icon"><img :src="getImgUrl(game.icon)"></b-col>
						<b-col class="game-name"><h4>{{ game.name }}</h4></b-col>
					</b-row>
				</b-list-group-item>
				
				<b-list-group-item active class="footer"></b-list-group-item>
			</b-list-group>

			<b-row class="more-games" v-if="this.more.length>0">
				<div class="game" v-for="(game, idx) in more" :key="idx" @mouseenter="gameHover(game)" @click="gameClick(game)"><img :src="getImgUrl(game.icon)" /></div>
			</b-row>

			
			

		</b-col>

		<b-col cols="4" class="d-none d-sm-block student-game-panel-container">

			<b-card :title="selectedGame.name" :img-src="getImgUrl(selectedGame.screenshot)" img-alt="Image" img-top class="student_game_panel">
				<b-card-text style="min-height:100px;">{{selectedGame.description }}</b-card-text>
				
				<b-card-footer class="play-now" @click="gameClick(selectedGame)"><font-awesome-icon icon="play-circle"/> Click to Play!</b-card-footer>
			</b-card>

		</b-col>
	</b-row>

</b-container>
  </div>
</template>

<script>
import json from '../assets/json/student_menu.json'

export default {
  name: 'Student',
  props: {
    grade: String
  },
  data() {
    return {
      games: [],
      more: [],
      selectedGame: {}
    }
  },
  watch: {
    grade: function() {
		this.updateGrade();
    }
  },
  beforeMount(){
	if(this.grade==undefined){
		this.grade = "prek";
	}
	this.updateGrade();
  },
  methods: {
	updateGrade(){
		this.games = json[this.grade].games;
		this.more = json[this.grade].more;
		console.log(this.grade);
		this.selectedGame=this.games[0];
	},
	gameHover(game){
		this.selectedGame = game;
	},
	gameClick(game){
		console.log("launching "+game.route);
		this.$router.push(game.route);
	},
	getImgUrl(pic) {
		return require('../assets/'+pic);
	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.island {
  background-image:url("../assets/img/world/island_test.jpg");
  background-position: 0 -90px;
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  height:1110px;
  border:none;
}

.semitransparent {
  background-color: rgba(255,255,255,0.7);
}

.semitransparent:hover {
  background-color: #FFCC00!important;
}

.game-select {
  margin: 10px;
}

.game-select .heading {
  border-top-left-radius: 20px!important;
  border-top-right-radius: 20px!important;
}

.game-select .footer {
  min-height: 30px;
  border-bottom-left-radius: 20px!important;
  border-bottom-right-radius: 20px!important;
}

.game-select .game-name {
	text-align: left;
	margin-top: 7px;
}

.game-select .game-icon img {
	height:40px;
	overflow:hidden;
	margin-top:4px;
}

.island a {
  color: black;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}


.lp-submenu {
	background-color:#FFCC00;
	padding:0 20px;
	border-bottom: 2px solid black;
	border-top:1px solid white;
}

.play-now{
	text-align:center;
	background-color: #FFCC00;
}

.student-game-panel-container {
	padding-left:0px;
}
.student_game_panel {
	margin: 10px;
	border-radius: 20px;
	background-color: rgba(255,255,255,0.8);
}
.student_game_panel .default_image {
	width:80%; 
	overflow:hidden;
	border-radius: 30px;
}

.student_game_panel img {
	width:100%; 
	overflow:hidden;
	border-radius: 26px;
}

.more-games {
	background-color: rgba(255,255,255,0.6);
	margin: 10px;
	margin-top: 20px;
	border-radius: 20px;
	padding: 10px;
}

.more-games .game img {
	width: 80px;
	height: 60px;
	display:inline-block;
	border-radius: 4px;
	margin:4px;
	padding:0px;
	top:0px;
	overflow:hidden
}

.more-games .game img:hover {
	border: 4px;
	border-style: solid;
	border-color: #FFCC00;
}

.student-container {
	margin-top: 20px;
}

.router-link-exact-active {
  background:#003366;
  color: white !important;
}
</style>
